import authentificationLocale from "@/assets/i18n/en/authentification.json";
import bonusOperationsLocale from "@/apps/whiteLabelWebsite/bonus/i18n/en/bonusOperations.json";
import buybackBonusLocale from "@/apps/shared/buyback/i18n/en/bonus.json";
import buybackDetailsLocale from "@/apps/dashboard/buyback/i18n/en/buybackDetails.json";
import buybackLocale from "@/apps/shared/buyback/i18n/en/buyback.json";
import buybackProductSearchLocale from "@/apps/shared/buyback/i18n/en/buybackProductSearch.json";
import buybacksQuarantineLocale from "@/apps/dashboard/buyback/i18n/en/buybackQuarantine.json";
import cartCheckout from "@/apps/shared/buyback/i18n/en/cartCheckout.json";
import cartLocale from "@/apps/shared/buyback/i18n/en/cart.json";
import cartMinValueForm from "@/assets/i18n/en/cartMinValueForm.json";
import categoryFilterLocale from "@/assets/i18n/en/categoryFilter.json";
import categoryLocale from "@/assets/i18n/en/category.json";
import categorySearchLocale from "@/assets/i18n/en/categorySearch.json";
import circuitsLocale from "@/assets/i18n/en/circuits.json";
import clientsLocale from "@/assets/i18n/en/client.json";
import connectorsLocale from "@/assets/i18n/en/connector.json";
import cookiesPolicyLocale from "@/apps/whiteLabelWebsite/whiteLabel/i18n/en/cookiesPolicy.json";
import deliveryStatusesLocale from "@/apps/dashboard/transport/i18n/en/deliveryStatuses.json";
import designLocale from "@/assets/i18n/en/design.json";
import diagnosticLocale from "@/assets/i18n/en/diagnostic.json";
import entitiesLocale from "@/assets/i18n/en/entity.json";
import enumsLocale from "@/assets/i18n/en/enum.json";
import errorsLocale from "@/assets/i18n/en/errors.json";
import estimateConfigLocale from "@/apps/dashboard/estimate/assets/i18n/en/estimateConfig.json";
import estimateLocale from "@/apps/shared/buyback/i18n/en/estimate.json";
import expeditionLocale from "@/apps/dashboard/transport/i18n/en/expedition.json";
import exportCatalogLocale from "@/apps/dashboard/catalog/assets/i18n/en/export.json";
import exportsLocale from "@/assets/i18n/en/exports.json";
import fintectureLocale from "@/apps/shared/payment/i18n/en/fintecture.json";
import footerLocale from "@/assets/i18n/en/footer.json";
import footerWebLocale from "@/apps/whiteLabelWebsite/whiteLabel/i18n/en/footer.json";
import generalSettings from "@/assets/i18n/en/generalSettings.json";
import giftCardBoulangerLocale from "@/apps/shared/payment/i18n/en/giftCardBoulanger.json";
import headerLocale from "@/assets/i18n/en/header.json";
import homeConfigLocale from "@/assets/i18n/en/homeConfig.json";
import homeDashboardLocale from "@/assets/i18n/en/homeDashboard.json";
import homeWidgetsLocale from "@/assets/i18n/en/homeWidgets.json";
import importsLocale from "@/assets/i18n/en/imports.json";
import instantSearchLocale from "@/assets/i18n/en/instantSearch.json";
import internalSftpLocale from "@/assets/i18n/en/internalSftp.json";
import itemRefurbStepsLocale from "@/assets/i18n/en/itemRefurbSteps.json";
import linkRetailerBuyer from "@/apps/dashboard/organization/assets/i18n/en/linkRetailerBuyer.json";
import litigationLocale from "@/assets/i18n/en/litigation.json";
import loginLocale from "@/assets/i18n/en/login.json";
import mangopayLocale from "@/apps/shared/payment/i18n/en/mangopay.json";
import manualPaymentLocale from "@/apps/shared/payment/i18n/en/manualPayment.json";
import menuLocale from "@/assets/i18n/en/menu.json";
import modalLocale from "@/assets/i18n/en/modal.json";
import notAvailableLocale from "@/assets/i18n/en/notAvailable.json";
import offerCardLocale from "@/assets/i18n/en/offerCard.json";
import oglobaLocale from "@/apps/shared/payment/i18n/en/ogloba.json";
import packingWithLabel from "@/apps/dashboard/transport/i18n/en/packingWithLabel.json";
import passwordLocale from "@/assets/i18n/en/password.json";
import paymentModesLocale from "@/apps/dashboard/payment/i18n/en/paymentMode.json";
import paymentSearch from "@/apps/dashboard/payment/i18n/en/paymentSearch.json";
import paymentStatusesLocale from "@/apps/dashboard/payment/i18n/en/paymentStatuses.json";
import paymentTypesLocale from "@/apps/dashboard/payment/i18n/en/paymentTypes.json";
import premiumFeatureBonusDepositLocale from "@/connectors/PremiumFeature/BonusDeposit/i18n/bonusDeposit.en.json";
import premiumFeatureNotConnector from "@/assets/i18n/en/premiumFeatureNotConnector.json";
import preselectedBuybackLocale from "@/assets/i18n/en/preselectedBuyback.json";
import productLocale from "@/assets/i18n/en/product.json";
import refurbDiagnosticLocale from "@/apps/dashboard/refurbDiagnosis/i18n/en/refurbDiagnosis.json";
import refurbStepLocale from "@/assets/i18n/en/refurbStep.json";
import searchItemLocale from "@/apps/dashboard/buybackDiagnostic/assets/i18n/en/searchItem.json";
import searchLocale from "@/apps/dashboard/catalog/assets/i18n/en/search.json";
import sharedLocale from "@/assets/i18n/en/shared.json";
import statisticLocale from "@/assets/i18n/en/statistic.json";
import stepBar from "@/assets/i18n/en/stepbar.json";
import stockItem from "@/apps/dashboard/itemLocation/i18n/en/stockItem.json";
import stockLocale from "@/apps/dashboard/itemLocation/i18n/en/stock.json";
import tagsLocale from "@/assets/i18n/en/tags.json";
import trackingSheet from "@/assets/i18n/en/trackingSheet.json";
import transferOrderLocale from "@/assets/i18n/en/transferOrder.json";
import transferOrderSettingsLocale from "@/assets/i18n/en/transferOrderSettings.json";
import transportsList from "@/apps/dashboard/transport/i18n/en/transportsList.json";
import usersLocale from "@/apps/dashboard/user/assets/i18n/en/user.json";
import verificationLocale from "@/apps/dashboard/buyback/i18n/en/verification.json";
import warehouseCheckin from "@/apps/dashboard/itemLocation/i18n/en/warehouseCheckin.json";
import warehouseDispatchLocale from "@/assets/i18n/en/warehouseDispatch.json";
import warehouseLocale from "@/assets/i18n/en/warehouse.json";
// !!! keep the alphabetical order

export const locale = {
  ...authentificationLocale,
  ...bonusOperationsLocale,
  ...buybackBonusLocale,
  ...buybackDetailsLocale,
  ...buybackLocale,
  ...buybackProductSearchLocale,
  ...buybacksQuarantineLocale,
  ...cartCheckout,
  ...cartLocale,
  ...cartMinValueForm,
  ...categoryFilterLocale,
  ...categoryLocale,
  ...categorySearchLocale,
  ...circuitsLocale,
  ...clientsLocale,
  ...connectorsLocale,
  ...cookiesPolicyLocale,
  ...deliveryStatusesLocale,
  ...designLocale,
  ...diagnosticLocale,
  ...entitiesLocale,
  ...enumsLocale,
  ...errorsLocale,
  ...estimateConfigLocale,
  ...estimateLocale,
  ...expeditionLocale,
  ...exportCatalogLocale,
  ...exportsLocale,
  ...fintectureLocale,
  ...footerLocale,
  ...footerWebLocale,
  ...generalSettings,
  ...giftCardBoulangerLocale,
  ...headerLocale,
  ...homeConfigLocale,
  ...homeDashboardLocale,
  ...homeWidgetsLocale,
  ...importsLocale,
  ...instantSearchLocale,
  ...internalSftpLocale,
  ...itemRefurbStepsLocale,
  ...linkRetailerBuyer,
  ...litigationLocale,
  ...loginLocale,
  ...mangopayLocale,
  ...manualPaymentLocale,
  ...menuLocale,
  ...modalLocale,
  ...notAvailableLocale,
  ...offerCardLocale,
  ...oglobaLocale,
  ...packingWithLabel,
  ...passwordLocale,
  ...paymentModesLocale,
  ...paymentSearch,
  ...paymentStatusesLocale,
  ...paymentTypesLocale,
  ...premiumFeatureBonusDepositLocale,
  ...premiumFeatureNotConnector,
  ...preselectedBuybackLocale,
  ...productLocale,
  ...refurbDiagnosticLocale,
  ...refurbStepLocale,
  ...searchItemLocale,
  ...searchLocale,
  ...sharedLocale,
  ...statisticLocale,
  ...stepBar,
  ...stockItem,
  ...stockLocale,
  ...tagsLocale,
  ...trackingSheet,
  ...transferOrderLocale,
  ...transferOrderSettingsLocale,
  ...transportsList,
  ...usersLocale,
  ...verificationLocale,
  ...warehouseCheckin,
  ...warehouseDispatchLocale,
  ...warehouseLocale,
  // !!! keep the alphabetical order
};
